import { adapter, TITLES_FEATURE_KEY, TitlesPartialState, TitlesState } from './titles.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getTitlesState = createFeatureSelector<
  TitlesPartialState,
  TitlesState
>(TITLES_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getError = createSelector( getTitlesState, (state:TitlesState) => state.error );

const getAllTitles = createSelector(
  getTitlesState,
  selectAll
);

const getAllTitlesById = createSelector(
  getTitlesState,
  selectEntities
);

const getLastCreatedId = createSelector( getTitlesState, (state:TitlesState) => state.lastCreatedId );

const getIsSearching = createSelector( getTitlesState, (state:TitlesState) => state.isSearching );

const getSearchResultIds = createSelector( getTitlesState, (state:TitlesState) => state.searchResultIds );

const getSearchResults = createSelector( getAllTitlesById, getSearchResultIds, (entities, searchResultIds) => {
  return searchResultIds.map(id => entities[id]);
})

export const TitlesQuery = {
  getError,
  getAllTitles,
  getAllTitlesById,
  getLastCreatedId,
  getIsSearching,
  getSearchResults
};
